import { makeActionCreator } from '../../config/store/utils'
import { getTopSuppliers, getSupplierDetail } from '../../services/charts'

export const SUPPLIERS = 'SUPPLIERS'
export const SUPPLIERS_ERROR = 'SUPPLIERS_ERROR'
export const SUPPLIERS_SUCCESS = 'SUPPLIERS_SUCCESS'
export const SUPPLIERSDETAILS_SUCCESS = 'SUPPLIERSDETAILS_SUCCESS'
export const onSuppliers = makeActionCreator(SUPPLIERS)
export const onSuppliersError = makeActionCreator(SUPPLIERS_ERROR, 'payload')
export const onSuppliersSuccess = makeActionCreator(SUPPLIERS_SUCCESS, 'payload')
export const onSuppliersDetailsSuccess = makeActionCreator(SUPPLIERSDETAILS_SUCCESS, 'payload')
export const onSuppliersThunk = (year, idEntity) => async dispatch => {
  dispatch(onSuppliers())

  try {
    const response = await getTopSuppliers({ idEntity, year })

    if (response.data.success !== 'OK') {
      return dispatch(onSuppliersError(response.data.errores))
    }

    return dispatch(onSuppliersSuccess(response.data.payload))
  } catch (error) {
    return dispatch(onSuppliersError(error))
  }
}
export const onSuppliersDetailsThunk = (year, idEntity, dni) => async dispatch => {
  dispatch(onSuppliers())

  try {
    const response = await getSupplierDetail({ idEntity, dni, year })

    if (response.data.success !== 'OK') {
      return dispatch(onSuppliersError(response.data.errores))
    }

    const totalAmount = response.data.payload.reduce((prevAmount, nextAmount) => {
      return prevAmount + nextAmount.clpgrossAmount
    }, 0)
    const totalPO = response.data.payload.reduce((prevAmount, nextAmount) => {
      return prevAmount + nextAmount.ponumber
    }, 0)
    const csvStructure = [
      ['Proveeedor', 'Mes', 'N° de órdenes de compra del mes', 'Monto transado en el mes (CLP)'],
      ...response.data.payload.map(item => [item.provider, item.month, item.monthNumber, item.clpgrossAmount])
    ]

    return dispatch(
      onSuppliersDetailsSuccess({
        csvStructure,
        totalAmount,
        totalPO,
        detailList: response.data.payload
      })
    )
  } catch (error) {
    return dispatch(onSuppliersError(error))
  }
}
